import { Link, useLocation } from "react-router-dom";
import { Home, Tag, Truck, PackageSearch, UserRound } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { useBodyClass } from "@/lib/useBodyClass";

const HIDDEN_PREFIXES = ["/admin", "/reservar", "/pago"];

const itemClass = (active) =>
  `flex flex-col items-center justify-center gap-1 h-full text-[11px] font-medium transition-colors duration-150 ${
    active ? "text-cyan-600" : "text-slate-500 active:text-cyan-600"}`;

export const MobileBottomNav = () => {
  const { pathname } = useLocation();
  const { user } = useAuth();
  const visible = !HIDDEN_PREFIXES.some((p) => pathname.startsWith(p));
  useBodyClass("has-bottom-nav", visible);

  if (!visible) return null;

  const goPrices = (e) => {
    if (pathname !== "/") return;
    e.preventDefault();
    document.getElementById("precios-tienda")?.scrollIntoView({ behavior: "smooth" });
  };
  const accountTo = user ? "/cuenta/panel" : "/cuenta";
  const accountActive = pathname.startsWith("/cuenta");

  return (
    <nav
      data-testid="mobile-bottom-nav"
      aria-label="Navegación móvil"
      className="lg:hidden fixed bottom-0 inset-x-0 z-40 bg-white/95 backdrop-blur-md border-t border-slate-200 shadow-[0_-8px_24px_-12px_rgba(15,23,42,0.18)] pb-[env(safe-area-inset-bottom)]"
    >
      <div className="grid grid-cols-5 h-16">
        <Link to="/" data-testid="bottom-nav-inicio" className={itemClass(pathname === "/")}>
          <Home className="h-5 w-5" /> Inicio
        </Link>
        <a href="/#precios-tienda" onClick={goPrices} data-testid="bottom-nav-precios" className={itemClass(false)}>
          <Tag className="h-5 w-5" /> Precios
        </a>
        <Link to="/reservar" data-testid="bottom-nav-reservar" className="flex flex-col items-center justify-end pb-1.5 gap-1 text-[11px] font-semibold text-cyan-700">
          <span className="-mt-6 flex items-center justify-center h-14 w-14 rounded-full bg-gradient-to-br from-cyan-400 to-cyan-600 text-white shadow-lg shadow-cyan-500/40 ring-4 ring-white transition-transform duration-150 active:scale-95">
            <Truck className="h-6 w-6" />
          </span>
          Reservar
        </Link>
        <Link to="/seguimiento" data-testid="bottom-nav-seguimiento" className={itemClass(pathname === "/seguimiento")}>
          <PackageSearch className="h-5 w-5" /> Pedido
        </Link>
        <Link to={accountTo} data-testid="bottom-nav-cuenta" className={itemClass(accountActive)}>
          <UserRound className="h-5 w-5" /> Cuenta
        </Link>
      </div>
    </nav>
  );
};
